/**
 * Curated editor formatting (duplicated validation on the worker via tiptap-schema).
 * Keep client UI options in sync with these lists.
 */

export const EDITOR_FONT_FAMILIES: { label: string; value: string }[] = [
  { label: 'Default', value: '' },
  { label: 'Sans (site)', value: '"Source Sans 3", system-ui, sans-serif' },
  { label: 'Serif', value: 'Georgia, "Times New Roman", serif' },
  { label: 'Mono', value: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace' },
]

export const EDITOR_TEXT_COLORS: { label: string; value: string }[] = [
  { label: 'Default', value: '' },
  { label: 'Navy', value: '#0f172a' },
  { label: 'Ink', value: '#0c4a6e' },
  { label: 'Sea', value: '#0369a1' },
  { label: 'Aqua', value: '#0ea5e9' },
  { label: 'Buoy', value: '#b45309' },
  { label: 'Slate', value: '#1e293b' },
]

export const EDITOR_HIGHLIGHT_COLORS: { label: string; value: string }[] = [
  { label: 'Yellow', value: '#fef08a' },
  { label: 'Sand', value: '#e2e8f0' },
  { label: 'Mint', value: '#bbf7d0' },
  { label: 'Sky', value: '#bae6fd' },
]

const FONT_SET = new Set(EDITOR_FONT_FAMILIES.map(f => f.value).filter(Boolean))
const TEXT_COLOR_SET = new Set(
  EDITOR_TEXT_COLORS.map(c => c.value.toLowerCase()).filter(Boolean),
)
const HIGHLIGHT_COLOR_SET = new Set(EDITOR_HIGHLIGHT_COLORS.map(c => c.value.toLowerCase()))

const HEX6 = /^#[0-9a-f]{6}$/i

export function isAllowedFontFamily(value: string): boolean {
  return FONT_SET.has(value)
}

export function isAllowedTextColor(value: string): boolean {
  const v = value.trim().toLowerCase()
  return HEX6.test(v) && TEXT_COLOR_SET.has(v)
}

export function isAllowedHighlightColor(value: string): boolean {
  const v = value.trim().toLowerCase()
  return HEX6.test(v) && HIGHLIGHT_COLOR_SET.has(v)
}

export const TEXT_ALIGNMENTS = ['left', 'center', 'right', 'justify'] as const
export type TextAlignment = (typeof TEXT_ALIGNMENTS)[number]

export function isAllowedTextAlign(value: string): value is TextAlignment {
  return (TEXT_ALIGNMENTS as readonly string[]).includes(value)
}
